import Login from "../../components/auth/login/Login";

const LoginPage = () => {
    return <Login />;
};

export default LoginPage;
